import {$getModuleColor, $getModuleIcon} from "./appModules"

export const sidebarMenu: SidebarMenu = [
    {
        title: 'default',
        menu: [
            {
                title: 'menu.dashboard',
                path: '/',
                icon: $getModuleIcon('dashboard'),
                module: 'dashboard',
            },
            {
                title: 'menu.events',
                path: 'events',
                icon: $getModuleIcon('events'),
                module: 'events',
            },
            {
                title: 'menu.sets',
                path: 'questions-sets',
                icon: $getModuleIcon('sets'),
                module: 'sets',
            },
            {
                title: 'menu.mails',
                path: 'mails',
                icon: $getModuleIcon('mails'),
                module: 'mails',
                ability: ['view', 'mails']
            },
            {
                title: 'menu.settings',
                path: 'settings',
                icon: $getModuleIcon('settings'),
                color: $getModuleColor('settings'),
                module: 'settings',
                children: [
                    {
                        title: 'menu.organisation',
                        path: 'settings-internal-organisation-organisationBaseData',
                        ability: ['view', 'organisations']
                    },
                    {
                        title: 'menu.crisisManagers',
                        path: 'settings-crisisManagers',
                        ability: ['view', 'crisisManagers']
                    }
                ]
            },
            {
                title: 'menu.system',
                path: 'system',
                icon: $getModuleIcon('system'),
                color: $getModuleColor('system'),
                module: 'system',
                ability: ['admin', 'system'],
                children: [
                    {
                        title: 'menu.pool',
                        path: 'system-poolQuestions',
                        module: 'questions',
                        ability: ['provide', 'questions']
                    },
                    {
                        title: 'menu.baseData',
                        path: 'system-baseData',
                        module: 'system',
                        ability: ['admin', 'system']
                    },
                    {
                        title: 'menu.roles',
                        path: 'system-roles',
                        module: 'roles',
                        ability: ['admin', 'system']
                    },
                    {
                        title: 'menu.organisations',
                        path: 'system-organisations',
                        module: 'organisations',
                        ability: ['viewAny', 'organisations']
                    },
                    {
                        title: 'menu.users',
                        path: 'system-users',
                        icon: $getModuleIcon('users'),
                        color: $getModuleColor('users'),
                        module: 'users',
                        ability: ['viewAny', 'users']
                    },
                    {
                        title: 'menu.mailTemplates',
                        path: 'system-mailTemplates',
                        icon: $getModuleIcon('mailTemplates'),
                        color: $getModuleColor('mailTemplates'),
                        module: 'mailTemplates',
                        ability: ['viewAny', 'mailTemplates']
                    },
                    {
                        title: 'menu.billings',
                        path: 'system-billings',
                        icon: $getModuleIcon('billings'),
                        color: $getModuleColor('billings'),
                        module: 'billings',
                        ability: ['admin', 'system']
                    },
                    {
                        title: 'menu.billingRuns',
                        path: 'system-billingRuns',
                        icon: $getModuleIcon('billingRuns'),
                        color: $getModuleColor('billingRuns'),
                        module: 'billingRuns',
                        ability: ['admin', 'system']
                    },
                ]
            }
        ]
    }
]